import plants from "../../images/plants.jpg";

export const newsAnimation = [
  {
    image: plants,
    article: "Betino® has received confirmation from Organic Standard",
    date: "31.08.2023",
    read: 5,
  },
  {
    image: "",
    article: 'Agro Conference "Organic agriculture"',
    date: "29.08.2023",
    read: 3,
  },
  {
    image: "",
    article: 'Promotion "Wuxal for autumn cultivation"',
    date: "27.08.2023",
    read: 2,
  },
  {
    image: "",
    article: "Friendly seedlings under stressful conditions",
    date: "26.08.2023",
    read: 5,
  },
];
